// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var DateFns = require("../utils/DateFns.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_option = require("rescript/lib/js/js_option.js");
var ListUtils = require("../utils/ListUtils.bs.js");
var ArrayUtils = require("../utils/ArrayUtils.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");

var UnexpectedBlockType = /* @__PURE__ */Caml_exceptions.create("ContentBlock.UnexpectedBlockType");

var UnexpectedRequestSource = /* @__PURE__ */Caml_exceptions.create("ContentBlock.UnexpectedRequestSource");

function widthToClass(width) {
  switch (width) {
    case /* Auto */0 :
        return "w-auto";
    case /* Full */1 :
        return "w-full";
    case /* FourFifths */2 :
        return "w-4/5";
    case /* ThreeFifths */3 :
        return "w-3/5";
    case /* TwoFifths */4 :
        return "w-2/5";
    
  }
}

function decodeMarkdownContent(json) {
  return Json_decode.field("markdown", Json_decode.string, json);
}

function decodeFileContent(json) {
  return Json_decode.field("title", Json_decode.string, json);
}

function decodeImageContent(json) {
  var widthString = Json_decode.field("width", Json_decode.string, json);
  var width;
  switch (widthString) {
    case "Auto" :
        width = /* Auto */0;
        break;
    case "FourFifths" :
        width = /* FourFifths */2;
        break;
    case "Full" :
        width = /* Full */1;
        break;
    case "ThreeFifths" :
        width = /* ThreeFifths */3;
        break;
    case "TwoFifths" :
        width = /* TwoFifths */4;
        break;
    default:
      Rollbar.error("Encountered unexpected width for image content block: " + widthString);
      width = /* Auto */0;
  }
  return [
          Json_decode.field("caption", Json_decode.string, json),
          width
        ];
}

function decodeEmbedContent(json) {
  var requestSourceString = Json_decode.field("requestSource", Json_decode.string, json);
  var requestSource;
  switch (requestSourceString) {
    case "User" :
        requestSource = "User";
        break;
    case "VimeoUpload" :
        requestSource = "VimeoUpload";
        break;
    default:
      Rollbar.error("Unexpected requestSource encountered in ContentBlock.re: " + requestSourceString);
      throw {
            RE_EXN_ID: UnexpectedRequestSource,
            _1: requestSourceString,
            Error: new Error()
          };
  }
  return [
          Json_decode.field("url", Json_decode.string, json),
          Json_decode.optional((function (param) {
                  return Json_decode.field("embedCode", Json_decode.string, param);
                }), json),
          requestSource,
          Json_decode.optional((function (param) {
                  return Json_decode.field("lastResolvedAt", DateFns.decodeISO, param);
                }), json)
        ];
}

function decode(json) {
  var unknownBlockType = Json_decode.field("blockType", Json_decode.string, json);
  var blockType;
  switch (unknownBlockType) {
    case "audio" :
        var title = Json_decode.field("content", decodeFileContent, json);
        var url = Json_decode.field("fileUrl", Json_decode.string, json);
        var filename = Json_decode.field("filename", Json_decode.string, json);
        blockType = {
          TAG: /* Audio */4,
          _0: url,
          _1: title,
          _2: filename
        };
        break;
    case "embed" :
        var match = Json_decode.field("content", decodeEmbedContent, json);
        blockType = {
          TAG: /* Embed */3,
          _0: match[0],
          _1: match[1],
          _2: match[2],
          _3: match[3]
        };
        break;
    case "file" :
        var title$1 = Json_decode.field("content", decodeFileContent, json);
        var url$1 = Json_decode.field("fileUrl", Json_decode.string, json);
        var filename$1 = Json_decode.field("filename", Json_decode.string, json);
        blockType = {
          TAG: /* File */1,
          _0: url$1,
          _1: title$1,
          _2: filename$1
        };
        break;
    case "image" :
        var match$1 = Json_decode.field("content", decodeImageContent, json);
        var url$2 = Json_decode.field("fileUrl", Json_decode.string, json);
        blockType = {
          TAG: /* Image */2,
          _0: url$2,
          _1: match$1[0],
          _2: match$1[1]
        };
        break;
    case "markdown" :
        blockType = {
          TAG: /* Markdown */0,
          _0: Json_decode.field("content", decodeMarkdownContent, json)
        };
        break;
    default:
      throw {
            RE_EXN_ID: UnexpectedBlockType,
            _1: unknownBlockType,
            Error: new Error()
          };
  }
  return {
          id: Json_decode.field("id", Json_decode.string, json),
          blockType: blockType,
          sortIndex: Json_decode.field("sortIndex", Json_decode.$$int, json)
        };
}

function sort(blocks) {
  return ArrayUtils.copyAndSort((function (x, y) {
                return x.sortIndex - y.sortIndex | 0;
              }), blocks);
}

function id(t) {
  return t.id;
}

function blockType(t) {
  return t.blockType;
}

function sortIndex(t) {
  return t.sortIndex;
}

function makeMarkdownBlock(markdown) {
  return {
          TAG: /* Markdown */0,
          _0: markdown
        };
}

function makeImageBlock(fileUrl, caption, width) {
  return {
          TAG: /* Image */2,
          _0: fileUrl,
          _1: caption,
          _2: width
        };
}

function makeFileBlock(fileUrl, title, fileName) {
  return {
          TAG: /* File */1,
          _0: fileUrl,
          _1: title,
          _2: fileName
        };
}

function makeEmbedBlock(url, embedCode, requestSource, lastResolvedAt) {
  return {
          TAG: /* Embed */3,
          _0: url,
          _1: embedCode,
          _2: requestSource,
          _3: lastResolvedAt
        };
}

function makeAudioBlock(fileUrl, title, fileName) {
  return {
          TAG: /* Audio */4,
          _0: fileUrl,
          _1: title,
          _2: fileName
        };
}

function make(id, blockType, sortIndex) {
  return {
          id: id,
          blockType: blockType,
          sortIndex: sortIndex
        };
}

function makeFromJs(js) {
  var id = js.id;
  var sortIndex = js.sortIndex;
  var match = js.content;
  var variant = match.NAME;
  var blockType;
  if (variant === "FileBlock") {
    var content = match.VAL;
    blockType = {
      TAG: /* File */1,
      _0: content.url,
      _1: content.title,
      _2: content.filename
    };
  } else if (variant === "MarkdownBlock") {
    blockType = {
      TAG: /* Markdown */0,
      _0: match.VAL.markdown
    };
  } else if (variant === "EmbedBlock") {
    var content$1 = match.VAL;
    blockType = {
      TAG: /* Embed */3,
      _0: content$1.url,
      _1: content$1.embedCode,
      _2: content$1.requestSource,
      _3: Belt_Option.map(content$1.lastResolvedAt, DateFns.parseISO)
    };
  } else if (variant === "ImageBlock") {
    var content$2 = match.VAL;
    var match$1 = content$2.width;
    blockType = {
      TAG: /* Image */2,
      _0: content$2.url,
      _1: content$2.caption,
      _2: match$1 === "ThreeFifths" ? /* ThreeFifths */3 : (
          match$1 === "TwoFifths" ? /* TwoFifths */4 : (
              match$1 === "Auto" ? /* Auto */0 : (
                  match$1 === "Full" ? /* Full */1 : /* FourFifths */2
                )
            )
        )
    };
  } else {
    var content$3 = match.VAL;
    blockType = {
      TAG: /* Audio */4,
      _0: content$3.url,
      _1: content$3.title,
      _2: content$3.filename
    };
  }
  return {
          id: id,
          blockType: blockType,
          sortIndex: sortIndex
        };
}

function blockTypeAsString(blockType) {
  switch (blockType.TAG | 0) {
    case /* Markdown */0 :
        return "markdown";
    case /* File */1 :
        return "file";
    case /* Image */2 :
        return "image";
    case /* Embed */3 :
        return "embed";
    case /* Audio */4 :
        return "audio";
    
  }
}

function incrementSortIndex(t) {
  return {
          id: t.id,
          blockType: t.blockType,
          sortIndex: t.sortIndex + 1 | 0
        };
}

function reindex(ts) {
  return List.mapi((function (sortIndex, t) {
                return {
                        id: t.id,
                        blockType: t.blockType,
                        sortIndex: sortIndex
                      };
              }), ts);
}

function moveUp(t, ts) {
  return $$Array.of_list(reindex(ListUtils.swapUp(t, $$Array.to_list(sort(ts)))));
}

function moveDown(t, ts) {
  return $$Array.of_list(reindex(ListUtils.swapDown(t, $$Array.to_list(sort(ts)))));
}

function updateFile(title, t) {
  var match = t.blockType;
  if (match.TAG === /* File */1) {
    return {
            id: t.id,
            blockType: {
              TAG: /* File */1,
              _0: match._0,
              _1: title,
              _2: match._2
            },
            sortIndex: t.sortIndex
          };
  } else {
    return t;
  }
}

function updateImageCaption(t, caption) {
  var match = t.blockType;
  if (match.TAG === /* Image */2) {
    return {
            id: t.id,
            blockType: {
              TAG: /* Image */2,
              _0: match._0,
              _1: caption,
              _2: match._2
            },
            sortIndex: t.sortIndex
          };
  } else {
    return t;
  }
}

function updateImageWidth(t, width) {
  var match = t.blockType;
  if (match.TAG === /* Image */2) {
    return {
            id: t.id,
            blockType: {
              TAG: /* Image */2,
              _0: match._0,
              _1: match._1,
              _2: width
            },
            sortIndex: t.sortIndex
          };
  } else {
    return t;
  }
}

function updateMarkdown(markdown, t) {
  var match = t.blockType;
  if (match.TAG === /* Markdown */0) {
    return {
            id: t.id,
            blockType: {
              TAG: /* Markdown */0,
              _0: markdown
            },
            sortIndex: t.sortIndex
          };
  } else {
    return t;
  }
}

var ppx_printed_query = "fragment allFields on ContentBlock   {\nid  \nblockType  \nsortIndex  \ncontent  {\n__typename\n...on ImageBlock   {\ncaption  \nurl  \nfilename  \nwidth  \n}\n\n...on FileBlock   {\ntitle  \nurl  \nfilename  \n}\n\n...on AudioBlock   {\ntitle  \nurl  \nfilename  \n}\n\n...on MarkdownBlock   {\nmarkdown  \n}\n\n...on EmbedBlock   {\nurl  \nembedCode  \nrequestSource  \nlastResolvedAt  \n}\n\n}\n\n}\n";

function parse(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "id");
  var tmp;
  if (value$2 !== undefined) {
    var value$3 = Caml_option.valFromOption(value$2);
    var value$4 = Js_json.decodeString(value$3);
    tmp = value$4 !== undefined ? value$4 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$3));
  } else {
    tmp = Js_exn.raiseError("graphql_ppx: Field id on type ContentBlock is missing");
  }
  var value$5 = Js_dict.get(value$1, "blockType");
  var tmp$1;
  if (value$5 !== undefined) {
    var value$6 = Caml_option.valFromOption(value$5);
    var value$7 = Js_json.decodeString(value$6);
    tmp$1 = value$7 !== undefined ? value$7 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$6));
  } else {
    tmp$1 = Js_exn.raiseError("graphql_ppx: Field blockType on type ContentBlock is missing");
  }
  var value$8 = Js_dict.get(value$1, "sortIndex");
  var tmp$2;
  if (value$8 !== undefined) {
    var value$9 = Caml_option.valFromOption(value$8);
    var value$10 = Js_json.decodeNumber(value$9);
    tmp$2 = value$10 !== undefined ? value$10 | 0 : Js_exn.raiseError("graphql_ppx: Expected int, got " + JSON.stringify(value$9));
  } else {
    tmp$2 = Js_exn.raiseError("graphql_ppx: Field sortIndex on type ContentBlock is missing");
  }
  var value$11 = Js_dict.get(value$1, "content");
  var tmp$3;
  if (value$11 !== undefined) {
    var value$12 = Caml_option.valFromOption(value$11);
    var typename_obj = Js_json.decodeObject(value$12);
    if (typename_obj !== undefined) {
      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
      if (typename !== undefined) {
        var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
        if (typename$1 !== undefined) {
          switch (typename$1) {
            case "AudioBlock" :
                var value$13 = Js_option.getExn(Js_json.decodeObject(value$12));
                var value$14 = Js_dict.get(value$13, "title");
                var tmp$4;
                if (value$14 !== undefined) {
                  var value$15 = Caml_option.valFromOption(value$14);
                  var value$16 = Js_json.decodeString(value$15);
                  tmp$4 = value$16 !== undefined ? value$16 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$15));
                } else {
                  tmp$4 = Js_exn.raiseError("graphql_ppx: Field title on type AudioBlock is missing");
                }
                var value$17 = Js_dict.get(value$13, "url");
                var tmp$5;
                if (value$17 !== undefined) {
                  var value$18 = Caml_option.valFromOption(value$17);
                  var value$19 = Js_json.decodeString(value$18);
                  tmp$5 = value$19 !== undefined ? value$19 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$18));
                } else {
                  tmp$5 = Js_exn.raiseError("graphql_ppx: Field url on type AudioBlock is missing");
                }
                var value$20 = Js_dict.get(value$13, "filename");
                var tmp$6;
                if (value$20 !== undefined) {
                  var value$21 = Caml_option.valFromOption(value$20);
                  var value$22 = Js_json.decodeString(value$21);
                  tmp$6 = value$22 !== undefined ? value$22 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$21));
                } else {
                  tmp$6 = Js_exn.raiseError("graphql_ppx: Field filename on type AudioBlock is missing");
                }
                tmp$3 = {
                  NAME: "AudioBlock",
                  VAL: {
                    title: tmp$4,
                    url: tmp$5,
                    filename: tmp$6
                  }
                };
                break;
            case "EmbedBlock" :
                var value$23 = Js_option.getExn(Js_json.decodeObject(value$12));
                var value$24 = Js_dict.get(value$23, "url");
                var tmp$7;
                if (value$24 !== undefined) {
                  var value$25 = Caml_option.valFromOption(value$24);
                  var value$26 = Js_json.decodeString(value$25);
                  tmp$7 = value$26 !== undefined ? value$26 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$25));
                } else {
                  tmp$7 = Js_exn.raiseError("graphql_ppx: Field url on type EmbedBlock is missing");
                }
                var value$27 = Js_dict.get(value$23, "embedCode");
                var tmp$8;
                if (value$27 !== undefined) {
                  var value$28 = Caml_option.valFromOption(value$27);
                  var match = Js_json.decodeNull(value$28);
                  if (match !== undefined) {
                    tmp$8 = undefined;
                  } else {
                    var value$29 = Js_json.decodeString(value$28);
                    tmp$8 = value$29 !== undefined ? value$29 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$28));
                  }
                } else {
                  tmp$8 = undefined;
                }
                var value$30 = Js_dict.get(value$23, "requestSource");
                var tmp$9;
                if (value$30 !== undefined) {
                  var value$31 = Caml_option.valFromOption(value$30);
                  var value$32 = Js_json.decodeString(value$31);
                  if (value$32 !== undefined) {
                    switch (value$32) {
                      case "User" :
                          tmp$9 = "User";
                          break;
                      case "VimeoUpload" :
                          tmp$9 = "VimeoUpload";
                          break;
                      default:
                        tmp$9 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for EmbedRequestSource: " + value$32);
                    }
                  } else {
                    tmp$9 = Js_exn.raiseError("graphql_ppx: Expected enum value for EmbedRequestSource, got " + JSON.stringify(value$31));
                  }
                } else {
                  tmp$9 = Js_exn.raiseError("graphql_ppx: Field requestSource on type EmbedBlock is missing");
                }
                var value$33 = Js_dict.get(value$23, "lastResolvedAt");
                var tmp$10;
                if (value$33 !== undefined) {
                  var value$34 = Caml_option.valFromOption(value$33);
                  var match$1 = Js_json.decodeNull(value$34);
                  if (match$1 !== undefined) {
                    tmp$10 = undefined;
                  } else {
                    var value$35 = Js_json.decodeString(value$34);
                    tmp$10 = value$35 !== undefined ? value$35 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$34));
                  }
                } else {
                  tmp$10 = undefined;
                }
                tmp$3 = {
                  NAME: "EmbedBlock",
                  VAL: {
                    url: tmp$7,
                    embedCode: tmp$8,
                    requestSource: tmp$9,
                    lastResolvedAt: tmp$10
                  }
                };
                break;
            case "FileBlock" :
                var value$36 = Js_option.getExn(Js_json.decodeObject(value$12));
                var value$37 = Js_dict.get(value$36, "title");
                var tmp$11;
                if (value$37 !== undefined) {
                  var value$38 = Caml_option.valFromOption(value$37);
                  var value$39 = Js_json.decodeString(value$38);
                  tmp$11 = value$39 !== undefined ? value$39 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$38));
                } else {
                  tmp$11 = Js_exn.raiseError("graphql_ppx: Field title on type FileBlock is missing");
                }
                var value$40 = Js_dict.get(value$36, "url");
                var tmp$12;
                if (value$40 !== undefined) {
                  var value$41 = Caml_option.valFromOption(value$40);
                  var value$42 = Js_json.decodeString(value$41);
                  tmp$12 = value$42 !== undefined ? value$42 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$41));
                } else {
                  tmp$12 = Js_exn.raiseError("graphql_ppx: Field url on type FileBlock is missing");
                }
                var value$43 = Js_dict.get(value$36, "filename");
                var tmp$13;
                if (value$43 !== undefined) {
                  var value$44 = Caml_option.valFromOption(value$43);
                  var value$45 = Js_json.decodeString(value$44);
                  tmp$13 = value$45 !== undefined ? value$45 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$44));
                } else {
                  tmp$13 = Js_exn.raiseError("graphql_ppx: Field filename on type FileBlock is missing");
                }
                tmp$3 = {
                  NAME: "FileBlock",
                  VAL: {
                    title: tmp$11,
                    url: tmp$12,
                    filename: tmp$13
                  }
                };
                break;
            case "ImageBlock" :
                var value$46 = Js_option.getExn(Js_json.decodeObject(value$12));
                var value$47 = Js_dict.get(value$46, "caption");
                var tmp$14;
                if (value$47 !== undefined) {
                  var value$48 = Caml_option.valFromOption(value$47);
                  var value$49 = Js_json.decodeString(value$48);
                  tmp$14 = value$49 !== undefined ? value$49 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$48));
                } else {
                  tmp$14 = Js_exn.raiseError("graphql_ppx: Field caption on type ImageBlock is missing");
                }
                var value$50 = Js_dict.get(value$46, "url");
                var tmp$15;
                if (value$50 !== undefined) {
                  var value$51 = Caml_option.valFromOption(value$50);
                  var value$52 = Js_json.decodeString(value$51);
                  tmp$15 = value$52 !== undefined ? value$52 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$51));
                } else {
                  tmp$15 = Js_exn.raiseError("graphql_ppx: Field url on type ImageBlock is missing");
                }
                var value$53 = Js_dict.get(value$46, "filename");
                var tmp$16;
                if (value$53 !== undefined) {
                  var value$54 = Caml_option.valFromOption(value$53);
                  var value$55 = Js_json.decodeString(value$54);
                  tmp$16 = value$55 !== undefined ? value$55 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$54));
                } else {
                  tmp$16 = Js_exn.raiseError("graphql_ppx: Field filename on type ImageBlock is missing");
                }
                var value$56 = Js_dict.get(value$46, "width");
                var tmp$17;
                if (value$56 !== undefined) {
                  var value$57 = Caml_option.valFromOption(value$56);
                  var value$58 = Js_json.decodeString(value$57);
                  if (value$58 !== undefined) {
                    switch (value$58) {
                      case "Auto" :
                          tmp$17 = "Auto";
                          break;
                      case "FourFifths" :
                          tmp$17 = "FourFifths";
                          break;
                      case "Full" :
                          tmp$17 = "Full";
                          break;
                      case "ThreeFifths" :
                          tmp$17 = "ThreeFifths";
                          break;
                      case "TwoFifths" :
                          tmp$17 = "TwoFifths";
                          break;
                      default:
                        tmp$17 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for ImageWidth: " + value$58);
                    }
                  } else {
                    tmp$17 = Js_exn.raiseError("graphql_ppx: Expected enum value for ImageWidth, got " + JSON.stringify(value$57));
                  }
                } else {
                  tmp$17 = Js_exn.raiseError("graphql_ppx: Field width on type ImageBlock is missing");
                }
                tmp$3 = {
                  NAME: "ImageBlock",
                  VAL: {
                    caption: tmp$14,
                    url: tmp$15,
                    filename: tmp$16,
                    width: tmp$17
                  }
                };
                break;
            case "MarkdownBlock" :
                var value$59 = Js_option.getExn(Js_json.decodeObject(value$12));
                var value$60 = Js_dict.get(value$59, "markdown");
                var tmp$18;
                if (value$60 !== undefined) {
                  var value$61 = Caml_option.valFromOption(value$60);
                  var value$62 = Js_json.decodeString(value$61);
                  tmp$18 = value$62 !== undefined ? value$62 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$61));
                } else {
                  tmp$18 = Js_exn.raiseError("graphql_ppx: Field markdown on type MarkdownBlock is missing");
                }
                tmp$3 = {
                  NAME: "MarkdownBlock",
                  VAL: {
                    markdown: tmp$18
                  }
                };
                break;
            default:
              tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content returned unknown type " + typename$1);
          }
        } else {
          tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content has a __typename field that is not a string");
        }
      } else {
        tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content is missing the __typename field");
      }
    } else {
      tmp$3 = Js_exn.raiseError("graphql_ppx: Expected union Content to be an object, got " + JSON.stringify(value$12));
    }
  } else {
    tmp$3 = Js_exn.raiseError("graphql_ppx: Field content on type ContentBlock is missing");
  }
  return {
          id: tmp,
          blockType: tmp$1,
          sortIndex: tmp$2,
          content: tmp$3
        };
}

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var AllFields = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: "allFields",
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Fragments = {
  AllFields: AllFields
};

var ppx_printed_query$1 = "query ContentBlocksWithVersionsQuery($targetId: ID!, $targetVersionId: ID)  {\ncontentBlocks(targetId: $targetId, targetVersionId: $targetVersionId)  {\nid  \nblockType  \nsortIndex  \ncontent  {\n__typename\n...on ImageBlock   {\ncaption  \nurl  \nfilename  \nwidth  \n}\n\n...on FileBlock   {\ntitle  \nurl  \nfilename  \n}\n\n...on AudioBlock   {\ntitle  \nurl  \nfilename  \n}\n\n...on MarkdownBlock   {\nmarkdown  \n}\n\n...on EmbedBlock   {\nurl  \nembedCode  \nrequestSource  \nlastResolvedAt  \n}\n\n}\n\n}\n\ntargetVersions(targetId: $targetId)  {\nid  \ncreatedAt  \nupdatedAt  \n}\n\n}\n";

function parse$1(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "contentBlocks");
  var value$3 = Js_dict.get(value$1, "targetVersions");
  return {
          contentBlocks: value$2 !== undefined ? Js_option.getExn(Js_json.decodeArray(Caml_option.valFromOption(value$2))).map(function (value) {
                  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
                  var value$2 = Js_dict.get(value$1, "id");
                  var tmp;
                  if (value$2 !== undefined) {
                    var value$3 = Caml_option.valFromOption(value$2);
                    var value$4 = Js_json.decodeString(value$3);
                    tmp = value$4 !== undefined ? value$4 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$3));
                  } else {
                    tmp = Js_exn.raiseError("graphql_ppx: Field id on type ContentBlock is missing");
                  }
                  var value$5 = Js_dict.get(value$1, "blockType");
                  var tmp$1;
                  if (value$5 !== undefined) {
                    var value$6 = Caml_option.valFromOption(value$5);
                    var value$7 = Js_json.decodeString(value$6);
                    tmp$1 = value$7 !== undefined ? value$7 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$6));
                  } else {
                    tmp$1 = Js_exn.raiseError("graphql_ppx: Field blockType on type ContentBlock is missing");
                  }
                  var value$8 = Js_dict.get(value$1, "sortIndex");
                  var tmp$2;
                  if (value$8 !== undefined) {
                    var value$9 = Caml_option.valFromOption(value$8);
                    var value$10 = Js_json.decodeNumber(value$9);
                    tmp$2 = value$10 !== undefined ? value$10 | 0 : Js_exn.raiseError("graphql_ppx: Expected int, got " + JSON.stringify(value$9));
                  } else {
                    tmp$2 = Js_exn.raiseError("graphql_ppx: Field sortIndex on type ContentBlock is missing");
                  }
                  var value$11 = Js_dict.get(value$1, "content");
                  var tmp$3;
                  if (value$11 !== undefined) {
                    var value$12 = Caml_option.valFromOption(value$11);
                    var typename_obj = Js_json.decodeObject(value$12);
                    if (typename_obj !== undefined) {
                      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
                      if (typename !== undefined) {
                        var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
                        if (typename$1 !== undefined) {
                          switch (typename$1) {
                            case "AudioBlock" :
                                var value$13 = Js_option.getExn(Js_json.decodeObject(value$12));
                                var value$14 = Js_dict.get(value$13, "title");
                                var tmp$4;
                                if (value$14 !== undefined) {
                                  var value$15 = Caml_option.valFromOption(value$14);
                                  var value$16 = Js_json.decodeString(value$15);
                                  tmp$4 = value$16 !== undefined ? value$16 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$15));
                                } else {
                                  tmp$4 = Js_exn.raiseError("graphql_ppx: Field title on type AudioBlock is missing");
                                }
                                var value$17 = Js_dict.get(value$13, "url");
                                var tmp$5;
                                if (value$17 !== undefined) {
                                  var value$18 = Caml_option.valFromOption(value$17);
                                  var value$19 = Js_json.decodeString(value$18);
                                  tmp$5 = value$19 !== undefined ? value$19 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$18));
                                } else {
                                  tmp$5 = Js_exn.raiseError("graphql_ppx: Field url on type AudioBlock is missing");
                                }
                                var value$20 = Js_dict.get(value$13, "filename");
                                var tmp$6;
                                if (value$20 !== undefined) {
                                  var value$21 = Caml_option.valFromOption(value$20);
                                  var value$22 = Js_json.decodeString(value$21);
                                  tmp$6 = value$22 !== undefined ? value$22 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$21));
                                } else {
                                  tmp$6 = Js_exn.raiseError("graphql_ppx: Field filename on type AudioBlock is missing");
                                }
                                tmp$3 = {
                                  NAME: "AudioBlock",
                                  VAL: {
                                    title: tmp$4,
                                    url: tmp$5,
                                    filename: tmp$6
                                  }
                                };
                                break;
                            case "EmbedBlock" :
                                var value$23 = Js_option.getExn(Js_json.decodeObject(value$12));
                                var value$24 = Js_dict.get(value$23, "url");
                                var tmp$7;
                                if (value$24 !== undefined) {
                                  var value$25 = Caml_option.valFromOption(value$24);
                                  var value$26 = Js_json.decodeString(value$25);
                                  tmp$7 = value$26 !== undefined ? value$26 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$25));
                                } else {
                                  tmp$7 = Js_exn.raiseError("graphql_ppx: Field url on type EmbedBlock is missing");
                                }
                                var value$27 = Js_dict.get(value$23, "embedCode");
                                var tmp$8;
                                if (value$27 !== undefined) {
                                  var value$28 = Caml_option.valFromOption(value$27);
                                  var match = Js_json.decodeNull(value$28);
                                  if (match !== undefined) {
                                    tmp$8 = undefined;
                                  } else {
                                    var value$29 = Js_json.decodeString(value$28);
                                    tmp$8 = value$29 !== undefined ? value$29 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$28));
                                  }
                                } else {
                                  tmp$8 = undefined;
                                }
                                var value$30 = Js_dict.get(value$23, "requestSource");
                                var tmp$9;
                                if (value$30 !== undefined) {
                                  var value$31 = Caml_option.valFromOption(value$30);
                                  var value$32 = Js_json.decodeString(value$31);
                                  if (value$32 !== undefined) {
                                    switch (value$32) {
                                      case "User" :
                                          tmp$9 = "User";
                                          break;
                                      case "VimeoUpload" :
                                          tmp$9 = "VimeoUpload";
                                          break;
                                      default:
                                        tmp$9 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for EmbedRequestSource: " + value$32);
                                    }
                                  } else {
                                    tmp$9 = Js_exn.raiseError("graphql_ppx: Expected enum value for EmbedRequestSource, got " + JSON.stringify(value$31));
                                  }
                                } else {
                                  tmp$9 = Js_exn.raiseError("graphql_ppx: Field requestSource on type EmbedBlock is missing");
                                }
                                var value$33 = Js_dict.get(value$23, "lastResolvedAt");
                                var tmp$10;
                                if (value$33 !== undefined) {
                                  var value$34 = Caml_option.valFromOption(value$33);
                                  var match$1 = Js_json.decodeNull(value$34);
                                  if (match$1 !== undefined) {
                                    tmp$10 = undefined;
                                  } else {
                                    var value$35 = Js_json.decodeString(value$34);
                                    tmp$10 = value$35 !== undefined ? value$35 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$34));
                                  }
                                } else {
                                  tmp$10 = undefined;
                                }
                                tmp$3 = {
                                  NAME: "EmbedBlock",
                                  VAL: {
                                    url: tmp$7,
                                    embedCode: tmp$8,
                                    requestSource: tmp$9,
                                    lastResolvedAt: tmp$10
                                  }
                                };
                                break;
                            case "FileBlock" :
                                var value$36 = Js_option.getExn(Js_json.decodeObject(value$12));
                                var value$37 = Js_dict.get(value$36, "title");
                                var tmp$11;
                                if (value$37 !== undefined) {
                                  var value$38 = Caml_option.valFromOption(value$37);
                                  var value$39 = Js_json.decodeString(value$38);
                                  tmp$11 = value$39 !== undefined ? value$39 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$38));
                                } else {
                                  tmp$11 = Js_exn.raiseError("graphql_ppx: Field title on type FileBlock is missing");
                                }
                                var value$40 = Js_dict.get(value$36, "url");
                                var tmp$12;
                                if (value$40 !== undefined) {
                                  var value$41 = Caml_option.valFromOption(value$40);
                                  var value$42 = Js_json.decodeString(value$41);
                                  tmp$12 = value$42 !== undefined ? value$42 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$41));
                                } else {
                                  tmp$12 = Js_exn.raiseError("graphql_ppx: Field url on type FileBlock is missing");
                                }
                                var value$43 = Js_dict.get(value$36, "filename");
                                var tmp$13;
                                if (value$43 !== undefined) {
                                  var value$44 = Caml_option.valFromOption(value$43);
                                  var value$45 = Js_json.decodeString(value$44);
                                  tmp$13 = value$45 !== undefined ? value$45 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$44));
                                } else {
                                  tmp$13 = Js_exn.raiseError("graphql_ppx: Field filename on type FileBlock is missing");
                                }
                                tmp$3 = {
                                  NAME: "FileBlock",
                                  VAL: {
                                    title: tmp$11,
                                    url: tmp$12,
                                    filename: tmp$13
                                  }
                                };
                                break;
                            case "ImageBlock" :
                                var value$46 = Js_option.getExn(Js_json.decodeObject(value$12));
                                var value$47 = Js_dict.get(value$46, "caption");
                                var tmp$14;
                                if (value$47 !== undefined) {
                                  var value$48 = Caml_option.valFromOption(value$47);
                                  var value$49 = Js_json.decodeString(value$48);
                                  tmp$14 = value$49 !== undefined ? value$49 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$48));
                                } else {
                                  tmp$14 = Js_exn.raiseError("graphql_ppx: Field caption on type ImageBlock is missing");
                                }
                                var value$50 = Js_dict.get(value$46, "url");
                                var tmp$15;
                                if (value$50 !== undefined) {
                                  var value$51 = Caml_option.valFromOption(value$50);
                                  var value$52 = Js_json.decodeString(value$51);
                                  tmp$15 = value$52 !== undefined ? value$52 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$51));
                                } else {
                                  tmp$15 = Js_exn.raiseError("graphql_ppx: Field url on type ImageBlock is missing");
                                }
                                var value$53 = Js_dict.get(value$46, "filename");
                                var tmp$16;
                                if (value$53 !== undefined) {
                                  var value$54 = Caml_option.valFromOption(value$53);
                                  var value$55 = Js_json.decodeString(value$54);
                                  tmp$16 = value$55 !== undefined ? value$55 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$54));
                                } else {
                                  tmp$16 = Js_exn.raiseError("graphql_ppx: Field filename on type ImageBlock is missing");
                                }
                                var value$56 = Js_dict.get(value$46, "width");
                                var tmp$17;
                                if (value$56 !== undefined) {
                                  var value$57 = Caml_option.valFromOption(value$56);
                                  var value$58 = Js_json.decodeString(value$57);
                                  if (value$58 !== undefined) {
                                    switch (value$58) {
                                      case "Auto" :
                                          tmp$17 = "Auto";
                                          break;
                                      case "FourFifths" :
                                          tmp$17 = "FourFifths";
                                          break;
                                      case "Full" :
                                          tmp$17 = "Full";
                                          break;
                                      case "ThreeFifths" :
                                          tmp$17 = "ThreeFifths";
                                          break;
                                      case "TwoFifths" :
                                          tmp$17 = "TwoFifths";
                                          break;
                                      default:
                                        tmp$17 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for ImageWidth: " + value$58);
                                    }
                                  } else {
                                    tmp$17 = Js_exn.raiseError("graphql_ppx: Expected enum value for ImageWidth, got " + JSON.stringify(value$57));
                                  }
                                } else {
                                  tmp$17 = Js_exn.raiseError("graphql_ppx: Field width on type ImageBlock is missing");
                                }
                                tmp$3 = {
                                  NAME: "ImageBlock",
                                  VAL: {
                                    caption: tmp$14,
                                    url: tmp$15,
                                    filename: tmp$16,
                                    width: tmp$17
                                  }
                                };
                                break;
                            case "MarkdownBlock" :
                                var value$59 = Js_option.getExn(Js_json.decodeObject(value$12));
                                var value$60 = Js_dict.get(value$59, "markdown");
                                var tmp$18;
                                if (value$60 !== undefined) {
                                  var value$61 = Caml_option.valFromOption(value$60);
                                  var value$62 = Js_json.decodeString(value$61);
                                  tmp$18 = value$62 !== undefined ? value$62 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$61));
                                } else {
                                  tmp$18 = Js_exn.raiseError("graphql_ppx: Field markdown on type MarkdownBlock is missing");
                                }
                                tmp$3 = {
                                  NAME: "MarkdownBlock",
                                  VAL: {
                                    markdown: tmp$18
                                  }
                                };
                                break;
                            default:
                              tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content returned unknown type " + typename$1);
                          }
                        } else {
                          tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content has a __typename field that is not a string");
                        }
                      } else {
                        tmp$3 = Js_exn.raiseError("graphql_ppx: Union Content is missing the __typename field");
                      }
                    } else {
                      tmp$3 = Js_exn.raiseError("graphql_ppx: Expected union Content to be an object, got " + JSON.stringify(value$12));
                    }
                  } else {
                    tmp$3 = Js_exn.raiseError("graphql_ppx: Field content on type ContentBlock is missing");
                  }
                  return {
                          id: tmp,
                          blockType: tmp$1,
                          sortIndex: tmp$2,
                          content: tmp$3
                        };
                }) : Js_exn.raiseError("graphql_ppx: Field contentBlocks on type Query is missing"),
          targetVersions: value$3 !== undefined ? Js_option.getExn(Js_json.decodeArray(Caml_option.valFromOption(value$3))).map(function (value) {
                  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
                  var value$2 = Js_dict.get(value$1, "id");
                  var tmp;
                  if (value$2 !== undefined) {
                    var value$3 = Caml_option.valFromOption(value$2);
                    var value$4 = Js_json.decodeString(value$3);
                    tmp = value$4 !== undefined ? value$4 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$3));
                  } else {
                    tmp = Js_exn.raiseError("graphql_ppx: Field id on type TargetVersion is missing");
                  }
                  var value$5 = Js_dict.get(value$1, "createdAt");
                  var value$6 = Js_dict.get(value$1, "updatedAt");
                  return {
                          id: tmp,
                          createdAt: value$5 !== undefined ? Caml_option.valFromOption(value$5) : Js_exn.raiseError("graphql_ppx: Field createdAt on type TargetVersion is missing"),
                          updatedAt: value$6 !== undefined ? Caml_option.valFromOption(value$6) : Js_exn.raiseError("graphql_ppx: Field updatedAt on type TargetVersion is missing")
                        };
                }) : Js_exn.raiseError("graphql_ppx: Field targetVersions on type Query is missing")
        };
}

function make$1(targetId, targetVersionId, param) {
  return {
          query: ppx_printed_query$1,
          variables: Js_dict.fromArray([
                  [
                    "targetId",
                    targetId
                  ],
                  [
                    "targetVersionId",
                    targetVersionId !== undefined ? targetVersionId : null
                  ]
                ].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse$1
        };
}

function makeWithVariables(variables) {
  var targetId = variables.targetId;
  var targetVersionId = variables.targetVersionId;
  return {
          query: ppx_printed_query$1,
          variables: Js_dict.fromArray([
                  [
                    "targetId",
                    targetId
                  ],
                  [
                    "targetVersionId",
                    targetVersionId !== undefined ? targetVersionId : null
                  ]
                ].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse$1
        };
}

function makeVariables(targetId, targetVersionId, param) {
  return Js_dict.fromArray([
                [
                  "targetId",
                  targetId
                ],
                [
                  "targetVersionId",
                  targetVersionId !== undefined ? targetVersionId : null
                ]
              ].filter(function (param) {
                  return !Js_json.test(param[1], /* Null */5);
                }));
}

function definition_2(graphql_ppx_use_json_variables_fn, targetId, targetVersionId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray([
                    [
                      "targetId",
                      targetId
                    ],
                    [
                      "targetVersionId",
                      targetVersionId !== undefined ? targetVersionId : null
                    ]
                  ].filter(function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    })));
}

var definition = [
  parse$1,
  ppx_printed_query$1,
  definition_2
];

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var Query = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  make: make$1,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

exports.UnexpectedBlockType = UnexpectedBlockType;
exports.UnexpectedRequestSource = UnexpectedRequestSource;
exports.widthToClass = widthToClass;
exports.decodeMarkdownContent = decodeMarkdownContent;
exports.decodeFileContent = decodeFileContent;
exports.decodeImageContent = decodeImageContent;
exports.decodeEmbedContent = decodeEmbedContent;
exports.decode = decode;
exports.sort = sort;
exports.id = id;
exports.blockType = blockType;
exports.sortIndex = sortIndex;
exports.makeMarkdownBlock = makeMarkdownBlock;
exports.makeImageBlock = makeImageBlock;
exports.makeFileBlock = makeFileBlock;
exports.makeEmbedBlock = makeEmbedBlock;
exports.makeAudioBlock = makeAudioBlock;
exports.make = make;
exports.makeFromJs = makeFromJs;
exports.blockTypeAsString = blockTypeAsString;
exports.incrementSortIndex = incrementSortIndex;
exports.reindex = reindex;
exports.moveUp = moveUp;
exports.moveDown = moveDown;
exports.updateFile = updateFile;
exports.updateImageCaption = updateImageCaption;
exports.updateImageWidth = updateImageWidth;
exports.updateMarkdown = updateMarkdown;
exports.Fragments = Fragments;
exports.Query = Query;
/* DateFns Not a pure module */
